import React, { useEffect, useState,useRef } from "react";
import * as Yup from "yup";
import clsx from "clsx";
import { Link , useNavigate,useLocation} from "react-router-dom";
import { useFormik } from "formik";
import { OTPResend } from "../redux/AuthCRUD";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toAbsoluteUrl } from "../../../../_jutemplate/helpers/AssetHelpers";

const initialValues = {
   otp: "",
};

const forgotPasswordSchema = Yup.object().shape({
   otp: Yup.string().required("OTP is required"),
});

export const OPTCode = () => {


  const [loading, setLoading] = useState(false);
  const [seconds, setSeconds] = useState(300); // Set OTP expiry time (300 seconds for 5 minutes)
  const [otpTiming, setOtpTiming] = useState(true);
 
  const location:any = useLocation();
  const navigate = useNavigate()

  const { otp,phone } = location?.state || {}; // Access passed data
  const userOTP = useRef(otp)

  // console.log(userOTP)

  useEffect(()=>{
    let interval:any;
    if(otpTiming && seconds > 0){
      interval = setInterval(() => {
        setSeconds((seconds) => seconds - 1);
      },1000);  
    } else if (seconds === 0) {
      clearInterval(interval);
      setOtpTiming(false)
    }
    return () => clearInterval(interval);
  },[otpTiming,seconds])

  const minutes = Math.floor(seconds / 60);
  const secs = seconds % 60;

  const resendCode = ()=>{
    setSeconds(300)
    setOtpTiming(true)
    OTPResend(phone).then(
      (res: any) => {
    
        if (res?.data?.success === true) {
          userOTP.current = res?.data?.otp
          console.log(userOTP)
          toast.success(res?.data?.message, {
            position: "top-right",
            theme: "colored",
          });
        } else {
          toast(res?.data?.message, {
             theme: "dark",
          });
        }
      },
      (err: any) => {
        setLoading(false);
        if (err?.response?.data?.success === false) {
          toast(err?.response?.data?.message, {
            theme: "dark",
          });
        }
        console.log(err);
      }
    );
  }

  const formik = useFormik({
    initialValues,
    validationSchema: forgotPasswordSchema,
    onSubmit: (values) => {
          if(userOTP.current==values.otp){
             navigate('/auth/reset-password',{ state: { otp:userOTP.current, phone:phone } })   
          } else {
            toast.error("Invalid OTP", {
              theme: "dark",
            });
          }
    },
  });

  useEffect(()=>{
    if(!otp){
      navigate('/auth')
    }
  },[])

  return (
    <>
    <>
      {/* alert */}
      {/* <ToastContainer /> */}

      <form
        className="form w-100"
        onSubmit={formik.handleSubmit}
        noValidate
        id="kt_login_signin_form"
      >
        {/* begin :: Heading */}
        <div className="d-flex flex-column align-items-center ">
          <img
            alt="Logo"
            src={toAbsoluteUrl("/media/logos/logo-hanay.svg")}
            // className="h-45px"
            style={{ height: "180px" }}
          />
          <h2
            className="fw-semibold m-0 mb-2"
            style={{ color: "#2F3367", fontSize: "18px" }}
          >
            Verify Now
          </h2>
          <h5
            className="fw-normal m-0"
            style={{ color: "#303468", fontSize: "18px" }}
          >
            We Send Code To Your Phone
          </h5>
        </div>

        {/* begin::Heading */}

        {/* begin::Form group */}
        <div className="fv-row mt-10">
          {/* <label className="form-label fs-6 fw-bolder text-dark">Phone Number</label> */}
          <input
            placeholder="OTP"
            {...formik.getFieldProps("otp")}
            className={clsx(
              "form-control form-control-lg form-control-solid rounded-2",
              { "is-invalid": formik.touched.otp && formik.errors.otp },
              {
                "is-valid": formik.touched.otp && !formik.errors.otp,
              }
            )}
            type="text"
            name="otp"
            autoComplete="off"
          />
          {formik.touched.otp && formik.errors.otp && (
            <div className="fv-plugins-message-container">
              <span role="alert" className="error text-danger">
                {formik.errors.otp}
              </span>
            </div>
          )}
        </div>
        <div className="d-flex justify-content-between align-items-center">
           <h6 style={{fontSize:'13px'}}>{`Code invalid after : ${minutes}:${secs < 10 ? '0' : ''}${secs} seconds`}</h6>
           <button onClick={resendCode} type='button' className="btn text-success">Resend</button>
        </div>
     

        {/* end::Form group */}

        {/* begin::Action */}

        <button
          type="submit"
          id="kt_sign_in_submit"
          className="loginbtn w-100 mt-10"
          // disabled={formik.isSubmitting || !formik.isValid}
          disabled={loading ? true : false}
        >
          {!loading && <span className="indicator-label">Submit</span>}
          {loading && (
            <span className="indicator-progress" style={{ display: "block" }}>
              Please wait...
              <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
            </span>
          )}
        </button>

        <div className="d-flex justify-content-end mt-5">
          <Link to="/login" className="ps-3 forgotpassword-link">
            Back to Login
          </Link>
        </div>
        {/* end::Action */}

      </form>
    </>
  </>
  )
}

